<div *ngFor="let error of errors;">
    <div class="error-primary" id="email-error" *ngIf="error.test">Not a valid email address.</div>
</div>
